<template>
    <div>
        <!--桌邊點餐、查詢-->
        <div class="order-list main" ref="main">
            <Banner id="bannerBrand" :storeImage="tableInfo.storeImage" />
            <div class="top-branch">{{ tableInfo.storeName }}</div>

            <div class="table-mun">
                <div class="text">{{ tableInfo.table }}</div>
                <div class="no">{{ tableInfo.tableNo }}</div>
            </div>

            <template v-if="isTablePass">

                <!--todo app桌邊點餐才出現以下資訊-->
                <div v-if="validInfo.isUser" class="text-center">
                    <div class="member-list">
                        <div class="avatar">
                            <div class="image_empty" v-if="dataObject.userData.avatar === ''"/>
                            <el-image v-else :src="dataObject.userData.avatar" fit="cover" lazy/>
                        </div>
                        <span>Hi,{{dataObject.userData.nickname || ''}} {{dataObject.userData.genderName || ''}}</span>
                    </div>
                    <h3>請於今日<span class="red">{{validInfo.timeFormat}}</span>前操作完成</h3>
                    <p class="small">(逾時需重新{{ noticeName }}點餐)</p>
                </div>

                <!--todo web桌邊點餐才出現手機號碼欄位-->
                <div v-show="!validInfo.isUser">
                    <div class="phone-list">
                        <img src="../../assets/images/table-order-phone.svg" class="mr-2">
                        <!--todo 國碼下拉-->
                        <CountryCodeSelect v-model="countryCodeData" :countryCodeData="countryCodeData" @visible-change="handleVisibleChange"/>
                        <el-input class="border-input" placeholder="請輸入手機號碼" v-model="inputInfo.phone" maxlength="19" :disabled="validInfo.isUser"
                                  :class="required(inputInfo.phone, 'phone')" type="tel" @focus="focusInput" />

                        <!--todo 號碼檢驗ok出現下面的 icon-->
                        <i class="green el-icon-check" v-if="isPhonePass" />
                    </div>
                    <div class="small text-center">※查詢訂單、累計優惠及通知用，請確實填寫</div>
                </div>

                <div class="people-number">
                    <template v-if="isRequiredPeople">
                        <span>大人<b class="red">*</b></span>
                        <el-input type="number" v-model.number="inputInfo.adult" pattern="[0-9]*" min="0"
                                  placeholder="請輸入人數" class="no-border" :class="required(inputInfo.adult)" @focus="focusInput" />
                        <span>小孩</span>
                        <el-input type="number" min="0" pattern="[0-9]*" v-model.number="inputInfo.child"
                                  placeholder="請輸入人數" class="no-border" />
                    </template>
                </div>
                <div class="CartButton">
                    <el-button @click="searchOrder()">查詢</el-button>
                    <el-button @click="createOrder()">點餐</el-button>
                </div>
            </template>

            <loading :active.sync=isLoading :can-cancel="false" :is-full-page="true"/>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import Banner from '@/views/order/components/Banner';
import * as constDefine from "@/store/constDefine";
import crypto from "@/util/crypto";
import * as mutationTypes from "@/store/mutationTypes";
import CountryCodeSelect from "@/components/CountryCodeSelect";
export default {
    name: "TableOrder",
    components: {
        Banner,//最上方商家橫幅＋星號
        CountryCodeSelect,
    },
    data() {
        return {
            isLoading: false,
            isTablePass: false,
            isPhonePass: false,
            dataObject: {},
            fromRouteName: null,
            storeCode: this.$route.params.storeCode,//從router寫入的
            tableInfo: {
                storeImage: '',
                storeName: '',
                table: '桌號',
                tableNo: '',
            },
            inputInfo: {
                phone: '',
                adult: '',
                child: '',
            },
            orderType: false,//判斷按查詢或點餐，判斷紅匡用
            //桌邊服務：金流付款完確認訂單狀態
            tmpId: this.$route.query.tmpId !== undefined ? parseInt(this.$crypto.decryptText(this.$route.query.tmpId)) : 0,
            validInfo: {
                isUser: false,
                timeFormat: '',
                token: '',
            },
            oinPayName: constDefine.OinPayName,
            isRequiredPeople: true,
            countryCodeData: {cnName: "台灣", code: "+886", countryEnNameCode: "TW+886", enName: "TW"}, //國碼物件與Calculator模組回傳一致
        }
    },
    created() {
        //如是從金流頁面回來，則判斷訂單的狀態
        if (this.tmpId > 0) {
            this.checkCompleteOrder(this.tmpId)
        }
        //set dataToken(給藍新返回商店按鈕用)
        if (!window.sessionStorage.getItem('homePage') && !this.$public.isCordova()) {
            this.$auth.setCurrentHost(window.location.href)
        }
    },
    mounted() {
        if (this.fromRouteName === null) {// NOTE 直接開啟或重整才會跑這裡
            if (typeof this.$route.query.dataToken === "string" && this.$route.query.dataToken !== "") {
                try {
                    let dataObject = this.$crypto.uriComponentToObject(this.$route.query.dataToken)

                    if (dataObject.userData !== undefined && dataObject.userData.countryCode !== undefined && dataObject.userData.countryName !== undefined) {
                        let countryCodeData = this.$public.getCountryData(dataObject.userData.countryCode, dataObject.userData.countryName);
                        this.countryCodeData = countryCodeData !== 0 ? countryCodeData : this.countryCodeData;
                    }

                    if (dataObject.usedType === constDefine.QRCodeUsedType.TableOrder) {

                        dataObject.routePath = this.$route.path;
                        dataObject.countryCodeData = this.countryCodeData;

                        if (typeof dataObject.userData !== "undefined") {
                            dataObject.userData.validTimestamp = dataObject.userData.timestamp + (30 * 60 * 1000);
                        }

                        let newDataObject = {
                            ...dataObject,
                            "prototypeObject": { ...dataObject },
                        }

                        sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(newDataObject));
                    } else {
                        this.$router.push({ name: 'Error' });
                        return false;
                    }
                } catch (e) {
                    this.$router.push({ name: 'Error' });
                    return false;
                }
            } else {
                this.$router.push({ name: 'Error' });
                return false;
            }
        }

        try {
            this.dataObject = this.$crypto.uriComponentToObject(sessionStorage.getItem(constDefine.StorageNameType.TableOrderDataToken));

            if (this.dataObject.userData !== undefined && this.dataObject.userData.countryCode !== undefined && this.dataObject.userData.countryName !== undefined) {
                let countryCodeData = this.$public.getCountryData(this.dataObject.userData.countryCode, this.dataObject.userData.countryName);
                this.countryCodeData = countryCodeData !== 0 ? countryCodeData : this.countryCodeData;
            } else if (this.dataObject.countryCodeData) {
                this.countryCodeData = this.dataObject.countryCodeData
            }

            if (typeof this.dataObject.phone !== "undefined") {
                this.inputInfo.phone = this.dataObject.phone;
                this.inputInfo.adult = this.dataObject.adult;
                this.inputInfo.child = this.dataObject.child;
            }

            if (typeof this.dataObject.userData !== "undefined") {
                if (this.inputInfo.phone === "") {
                    this.inputInfo.phone = this.dataObject.userData.phone || "";
                }

                let validTimestamp = this.dataObject.userData.validTimestamp

                if (this.dataObject.userData.userToken !== "") {
                    try {
                        //確認token正確性
                        this.$crypto.decryptText(this.dataObject.userData.userToken)

                        this.validInfo.isUser = true
                        this.validInfo.timeFormat = this.$public.dateFormat("hh:mm", new Date(validTimestamp));
                        this.validInfo.token = this.dataObject.userData.userToken
                        let userInfo = localStorage.getItem("userInfo")
                        userInfo = userInfo !== null ? this.$crypto.uriComponentToObject(userInfo) : "";
                        this.countryCodeData = userInfo === "" && (userInfo.countryCode === undefined || userInfo.countryCode === "") && (userInfo.countryName === undefined || userInfo.countryName === "") ? this.countryCodeData : this.$public.getCountryData(userInfo.countryCode, userInfo.countryName);

                        if (this.dataObject.isAppOpen) {
                            this.$store.commit("setIsMainCloseBtn", true)
                        }
                    } catch (e) {
                        this.dataObject.userData = undefined
                    }
                } else {
                    this.dataObject.userData = undefined
                }
            }

            this.setupData();
        } catch (e) {
            this.$router.push({ name: 'Error' });
            return false;
        }
    },
    beforeRouteEnter: function (to, from, next) {
        next(
            vm => {
                vm.fromRouteName = from.name;
            }
        );
    },
    computed: {
        //必填共用判斷
        required() {
            return (type, num) => {
                if (num === undefined) {
                    //不能為空值
                    if (this.orderType) {
                        return type === "" ? 'required' : ''
                    }

                } else {
                    switch (num) {
                        //手機
                        case 'phone':
                            return !this.$public.reg('phone', type) ? 'required' : ''
                    }
                }
            }
        },
        noticeName() {
            return this.dataObject.isWebLogin ? "登入" : "掃碼"
        },
    },
    methods: {
        handleVisibleChange(payload) {
            this.countryCodeData = payload.countryCodeData;
        },
        setupData() {
            this.isLoading = true
            this.$http.fetch`GetTableSetting${{
                tableId: this.dataObject.tableId,
                storeId: this.dataObject.storeId,
                storeCode: this.storeCode,
            }}
            ${json => {
                if (json.status) {
                    this.isTablePass = true;
                    this.tableInfo.storeName = (json.data.storeName !== "" && json.data.storeName !== " " ? json.data.brandName + " " + json.data.storeName : json.data.brandName);
                    this.tableInfo.storeImage = json.data.logoImage;
                    this.tableInfo.tableNo = json.data.tableNo;
                    if (this.validInfo.isUser) {
                        this.$auth.setAdminToken(this.validInfo.token);
                    } else {
                        this.$auth.setAdminToken(this.$crypto.decryptText(json.data.token));
                    }

                    this.isRequiredPeople = typeof json.data.isRequiredPeople === "undefined" ? true : json.data.isRequiredPeople;
                    if (!this.isRequiredPeople) {
                        this.inputInfo.adult = 1;
                        this.inputInfo.child = '';
                    }

                } else {
                    if (json.data) {
                        this.tableInfo.storeName = (json.data.storeName !== "" && json.data.storeName !== " " ? json.data.brandName + " " + json.data.storeName : json.data.brandName);
                        this.tableInfo.storeImage = json.data.logoImage;
                    }

                    this.$public.showNotify(json.message, json.status);
                    this.tableInfo.table = "";
                    this.tableInfo.tableNo = json.message;
                }
                this.isLoading = false
            }}`;
        },
        checkInput(type) {
            this.$el.style.setProperty('--borderColor222', `${"#EA4E5E"}`)
            if (this.$public.checkPhone(this.inputInfo.phone, this.countryCodeData) || this.validInfo.isUser) {
                if (type === "createOrder") {
                    if (typeof this.inputInfo.adult !== "number" || this.inputInfo.adult <= 0) {
                        this.$public.showNotify("請輸入大人人數", false);
                        return false;
                    } else if (this.inputInfo.adult > 100) {
                        this.$public.showNotify("大人人數最少1最多100", false);
                        return false;
                    } else if (typeof this.inputInfo.child === "number" && (this.inputInfo.child < 0 || this.inputInfo.child > 100)) {
                        this.$public.showNotify("小孩人數不可負數最多100", false);
                        return false;
                    }
                }

                this.dataObject = {
                    ...this.dataObject, ...{
                        "phone": this.inputInfo.phone,
                        "adult": this.inputInfo.adult,
                        "child": this.inputInfo.child,
                        "isChecked": true,
                        "countryCodeData": this.countryCodeData,
                    }
                }
                sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(this.dataObject));
                return true;
            } else {
                this.$public.showNotify("請確認手機號碼", false);
                return false;
            }
        },
        searchOrder() {
            this.orderType = false
            if (this.checkInput("searchOrder")) {
                if (this.dataObject.routePath) {
                    this.$router.push({ path: this.dataObject.routePath + "/record" })
                } else {
                    this.$router.push({ name: 'TableOrderRecord' });
                }
            }
        },
        createOrder() {
            if (this.validInfo.isUser) {
                let nowTimestamp = new Date().getTime()
                let validTimestamp = this.dataObject.userData.validTimestamp
                if (nowTimestamp > validTimestamp) {
                    this.$store.commit(mutationTypes.setPublicCommDialogData, {
                        isShowDialog: true,
                        outerContent: "點餐已逾時",
                        mainContent: `需要重新${this.noticeName}點餐嗎？`,
                        isCancel: true,
                        isResultEvent: true,
                        eventName: constDefine.triggerCloseBtn,
                    });
                    return false
                }
            }

            this.orderType = true
            if (this.checkInput("createOrder")) {
                //為了避免選完餐點後就關掉，下次再進來時看到舊資料，所以每次進去都清空
                this.takeoutId = 0;
                this.$public.clearCart(this);
                this.$router.push({ name: 'OrderList' });
            }
        },
        focusInput() {
            setTimeout(() => {
                this.$refs.main.scrollTop = 220
            }, 100)
        },
        checkCompleteOrder(tmpId) {
            this.$http.fetchWithEncrypt`PaymentCompleted${{
            orderTmpId: tmpId,
            }}
            ${(json) => {
                if (json.status) {
                    let dataToken = this.$crypto.objectToURIComponent({
                            "takeoutId": json.data.takeoutId,
                            "storeId": this.dataObject.storeId,
                            "prototypeObject": { ...this.dataObject.prototypeObject },
                        })
                    this.$router.push({ name: 'TableOrderComplete', query: { dataToken: dataToken } });
                }else{
                    this.$public.showNotify('抱歉：' + json.message, json.status);
                }
            }}`;
        },
    },
    watch: {
        'inputInfo.phone': function (value) {
            this.isPhonePass = this.$public.reg('phone', value);
        },
        '$store.state.publicCommDialogData.isShowDialog': function() {
            if (this.$route.name === 'TableOrder') {
                if (!this.$store.state.publicCommDialogData.isShowDialog && this.$store.state.publicCommDialogData.isResultEvent) {
                    if (this.$store.state.publicCommDialogData.result &&
                        this.$store.state.publicCommDialogData.eventName === constDefine.triggerCloseBtn) {
                        if (this.dataObject.isWebLogin) {
                            if (typeof this.dataObject.prototypeObject !== "undefined") {
                                let dataObject = {
                                    ...this.dataObject.prototypeObject,
                                    "prototypeObject": {...this.dataObject.prototypeObject},
                                }

                                sessionStorage.setItem(constDefine.StorageNameType.TableOrderDataToken, this.$crypto.objectToURIComponent(dataObject));
                                window.location.reload();
                            }
                        } else {
                            document.getElementById('closeBtn').click()
                        }
                    }

                    this.$store.commit(mutationTypes.setPublicCommDialogData, {
                        isResultEvent: false,
                        eventName: "",
                    });
                }
            }
        }
    },
}
</script>

<style lang="less" scoped src="../../less/order.less"/>
<style lang="less" scoped src="../../less/tableOrder.less"/>